import {Base,Axios} from "@/api/Base"

export class RemainingDownloadRemainingLeaveReport extends Base {
    path = "remainingVacation/downRemainingVacationLeaveReport"
    download(param = {}) {
        return Axios.get(this.path, { params: param,responseType: "blob" })
    }
}